import React from 'react';
// import jQuery from 'jquery';
import { BASEURL } from '../../../constant';

import {Helmet} from "react-helmet";

class foot extends React.Component {

    constructor(props) {
        super(props);
        //const { history } = this.props;
        this.state = {
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            logged_user_name: ''
        };
    }


    logoutFunc(e) {
        e.preventDefault();
        this.props.logoutSubmit();
    }
    logoutSess(e) {
        localStorage.clear();
        setTimeout(function () {
            window.location = "/";
        }, 1000);
    }
    componentDidMount() {
        if (this.state.logged !== 'true') {
            this.props.history.push('/');
        } else {
            this.setState({
                vendor_role: this.state.auth_data.role,
                access_url: this.state.auth_data.access,
                logged_user_name: this.state.auth_data.user_name
            })
        }
        // console.log('user data', this.state.auth_data)
    }

    render() {
        return (
              
            <React.Fragment>

            <div className="pull-right">
                <div className="notify-wrap">
                    <a href="javascript:;"><img src={BASEURL + "assets/images/notification-icon.svg"} alt="Notification" /></a>
                </div>
                <div className="profile-wrap dropdown">
                    <a href="#" className="avatar dropdown-toggle" data-toggle="dropdown">
                        {/* <span className="avatar-img"><img className="img-responsive" src={url + "assets/images/user-img-1.png"} alt={this.state.logged_user_name} /></span> */}
                        <span className="hidden-xs">{this.state.logged_user_name}</span>
                    </a>
                    <ul className="dropdown-menu">
                        {/* <li>
                            <a href="/"><img src="../assets/images/edit-icon.svg" alt="icon" />Edit Profile</a>
                        </li> */}
                        <li><a href="javascript:;"><img src={BASEURL + "assets/images/edit-icon.svg"} alt="icon" />Edit Profile</a></li>
                        <li><a href="javascript:;"><img src={BASEURL + "assets/images/settings-icon.svg"} alt="icon" />Change Password</a></li>
                        <li><a onClick={(e) => this.logoutSess(e)}><img src={BASEURL + "assets/images/turn-off-icon.svg"} alt="icon" />Logout</a></li>
                    </ul>
                </div>

              
            </div>
            </React.Fragment>

        )
    }
}
export default foot;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveparnter/foot.jsx